import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthSyncService } from '@app/auth/auth-sync.service';
import { environment } from '@environments/environment';

@Component({
  template: '',
})
export class LoggedOutComponent implements OnInit {
  private readonly DEBUG = environment.debug;

  constructor(
    private router: Router,
    private authSyncService: AuthSyncService
  ) {}

  private log(message: string, data?: any) {
    if (this.DEBUG) {
      // eslint-disable-next-line no-console
      console.log(`[LoggedOutComponent] ${message}`, data || '');
    }
  }

  ngOnInit() {
    // Ensure all tabs are cleared
    this.authSyncService.broadcastLogout().then(() => {
      this.log('Logout broadcast completed');
    });

    this.log('Scheduling redirect');
    setTimeout(() => {
      this.log('Redirecting to home');
      this.router.navigate(['/']);
    }, 100);
  }
}
